<template>
  <el-button-group>
    <el-button size="mini"
               @click="onReadCache">读取缓存
    </el-button>
    <el-button v-if="cloudCache"
               size="mini"
               icon="sj-icon-cloud-download"
               style="padding: 7px 10px;"
               @click="readCloudCache">
    </el-button>
  </el-button-group>
</template>

<script>
import CacheManage from '@views/question-review/components/CacheManage/index'
import convert from '@views/question-editor/format/convert.js'

export default {
  components: {},
  mixins: [],
  inject: ['page'],
  props: {
    orderId: [Number, String],
    tplId: [Number, String],
  },
  data () {
    return {
      cloudCache: null,
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {
    request('readOrderReviewCache', {
      id: this.orderId,
    }).then(res => {
      if (res.data) {
        try {
          this.cloudCache = {
            date: res.data.date,
            answers: convert.convertAnswers(this.page.questions, JSON.parse(res.data.templateresultjson)),
          }
        } catch (error) {
          console.error(error)
        }
      }
    })
  },
  mounted () {},
  methods: {
    /**
     * 读取缓存
     */
    onReadCache () {
      CacheManage.readCache(this.orderId + '_' + this.tplId, (val) => {
        this.$store.commit('orderReview/SET_CACHE_ANSWERS', val)
      })
    },
    readCloudCache () {
      this.$confirm(`保存在云端${this.cloudCache.date}的审核缓存， 确认读取？`, '提示', {type: 'warning'}).then(() => {
        this.$store.commit('orderReview/SET_CACHE_ANSWERS', this.cloudCache.answers)
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderReviewReadCacheButton.vue